
import {request} from "./request"
import * as tool from "./util"
import {getCookie,setCookie,delCookie} from "./cookie"
import {getConfig} from "../../config/js/tool"

//import mitt from "mitt"
// 空值：null、undefined、''、false、0、NaN
// 空对象：{} 或 new Object() 且自身无可枚举属性
function isEmptyOrEmptyObject(v) {
  // 1. 先处理所有“空值”
  if (v == null) return true;            // null / undefined
  if (typeof v !== 'object') return !v;  // 原始类型：'', 0, false, NaN 都算空

  // 2. 再处理对象：数组、日期、正则等都不算“空对象”
  return Object.keys(v).length === 0;
}
export default {
    install(app){
        app.config.globalProperties.$request=request
        app.config.globalProperties.getCookie=getCookie
        app.config.globalProperties.setCookie=setCookie
        app.config.globalProperties.delCookie=delCookie
        app.config.globalProperties.setSharedCookie=tool.setSharedCookie
        app.config.globalProperties.getSharedCookie=tool.getSharedCookie
        app.config.globalProperties.tool=tool
        var localObj = window.location;
        let commenUrl = process.env.VUE_APP_PUBLIC_PATH
        if(!commenUrl){
            commenUrl = localObj.protocol + "//" + localObj.host+process.env.VUE_APP_PUBLIC_NAME+'/sr/';
        }
        app.config.globalProperties.commenUrl = commenUrl
        let apiUrl = process.env.VUE_APP_BASE_API
        if(!apiUrl){
            apiUrl = localObj.protocol + "//" + localObj.host+process.env.VUE_APP_PUBLIC_NAME;
        }
        app.config.globalProperties.apiUrl = apiUrl
        app.config.globalProperties.UPLOADIMG = apiUrl+"/system/w/uploadImg"
        app.config.globalProperties.glob="global"
        //获取项目配置信息
        app.config.globalProperties.getConfig=getConfig
        app.config.globalProperties.redirectUrl=!isEmptyOrEmptyObject(getConfig('redirectUrl'))?getConfig('redirectUrl'):localObj.protocol + "//" + localObj.host
        app.config.globalProperties.localUrl=localObj.protocol + "//" + localObj.host
    }
}
